/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

// src/components/software/SoftwareTrustBar.jsx

import React from "react";

import {
  Smartphone,
  Layers3,
  ShieldCheck,
} from "lucide-react";

const SoftwareTrustBar = () => {
  return (

    <section
      className="
        px-6
        lg:px-10
        -mt-16
        relative
        z-20
      "
    >

      <div
        className="
          max-w-7xl
          mx-auto

          bg-white

          rounded-[32px]

          shadow-[0_15px_50px_rgba(0,0,0,0.08)]

          border
          border-gray-100

          p-8
        "
      >

        <div
          className="
            grid
            md:grid-cols-3
            gap-8
          "
        >

          {/* PRODUCTS */}

          <div className="flex gap-5">

            <div
              className="
                w-14
                h-14
                rounded-2xl

                bg-blue-100

                flex
                items-center
                justify-center

                text-blue-700
              "
            >
              <Smartphone size={28} />
            </div>

            <div>

              <div
                className="
                  font-black
                  text-xl
                  mb-2
                "
              >
                Mobile First
              </div>

              <div className="text-gray-500">

                Orion Edge delivers
                professional-grade financial
                tools optimized for mobile
                users and active traders.

              </div>

            </div>

          </div>


          {/* ECOSYSTEM */}

          <div className="flex gap-5">

            <div
              className="
                w-14
                h-14
                rounded-2xl

                bg-green-100

                flex
                items-center
                justify-center

                text-green-700
              "
            >
              <Layers3 size={28} />
            </div>

            <div>

              <div
                className="
                  font-black
                  text-xl
                  mb-2
                "
              >
                Unified Ecosystem
              </div>

              <div className="text-gray-500">

                Orion Analytics, Orion Edge
                and future Orion products
                are designed to work together
                as a single platform.

              </div>

            </div>

          </div>


          {/* TRUST */}

          <div className="flex gap-5">

            <div
              className="
                w-14
                h-14
                rounded-2xl

                bg-purple-100

                flex
                items-center
                justify-center

                text-purple-700
              "
            >
              <ShieldCheck size={28} />
            </div>

            <div>

              <div
                className="
                  font-black
                  text-xl
                  mb-2
                "
              >
                Built For Investors
              </div>

              <div className="text-gray-500">

                Developed from real-world
                investing, trading and
                analytics workflows rather
                than generic finance apps.

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>

  );
};

export default SoftwareTrustBar;